import { render } from "./PerfiladorAerosoles.vue?vue&type=template&id=c2757ed4"
import script from "./PerfiladorAerosoles.vue?vue&type=script&lang=js"
export * from "./PerfiladorAerosoles.vue?vue&type=script&lang=js"

import exportComponent from "/proyectos/programas-de-investigacion/cah-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__